import { bool, func, string } from 'prop-types';
import React from 'react';

import { getTooltipButtonWithText } from '../../../../generic/Tooltip';
import { COLORS } from '../../../../utils/constants';
import HELP_TEXTS from '../../../help-texts';

const TooltipButtonComponent = getTooltipButtonWithText(HELP_TEXTS);

function SubmitForReviewTooltipButton({ disabled, onClick, title, ...rest }) {
  return (
    <TooltipButtonComponent
      helpKey="submitForReview"
      section="statusChanges"
      resource="inv"
      disabled={disabled}
      showTooltip={disabled}
      onClick={onClick}
      {...rest}
      color={COLORS.SUCCESS}
    >
      {title}
    </TooltipButtonComponent>
  );
}

SubmitForReviewTooltipButton.propTypes = {
  disabled: bool.isRequired,
  onClick: func.isRequired,
  title: string.isRequired,
};

export default SubmitForReviewTooltipButton;
